import src from "IMAGE";
export default { src, width: 6000, height: 3600, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAARUlEQVR42l2MWwrAQAgD9/7nXd+KRYtg+xEUZpIjIsnMnfnvhQSAVNU8W6gQUSJiQ3fPs+EIVTKzV9gLBesO/Aj/6YjoPFx1nH2iqq2aAAAAAElFTkSuQmCC"};
